import { Typography, Checkbox } from '@mui/material';

import React, { useEffect, useState } from 'react';

import CommonTable from 'common/components/Table/CommonTable';
import { Column } from 'common/components/Table/CommonTableStyles';
import { pascalFormat } from 'common/utils/utilFunctions';

import styles from './DataAccessPermissions.module.scss';

interface IDataAcessPermissionsModulesProps {
	selectedPermissionModules?: any[];
	onAcessPermissionSelect: (data: any[]) => void;
	data: any[];
	clearButton: boolean;
	selectButton: boolean;
}

export interface IDataPermission {
	objectType: string;
	id: string;
	readPermissionId: string;
	readPermissionName: string;
	createPermissionId: string;
	createPermissionName: string;
	updatePermissionId: string;
	updatePermissionName: string;
	deletePermissionId: string;
	deletePermissionName: string;
	updateAllPermissionId: string;
	updateAllPermissionName: string;
	readAllPermissionId: string;
	readAllPermissionName: string;
}

const DataAccessPermissionsModule = (
	props: IDataAcessPermissionsModulesProps,
) => {
	const {
		data,
		onAcessPermissionSelect,
		selectButton,
		clearButton,
		selectedPermissionModules,
	} = props;

	const { checkboxUncheckedcolor, checkboxCheckedcolor } = styles;
	const [selectedIds, setselectedIds] = useState<string[]>([]);
	const getAllIds = () => {
		const allIds: any[] = [];
		data.forEach((ele: any) => {
			allIds.push(ele?.readAllPermissionId);
			allIds.push(ele?.updateAllPermissionId);
			allIds.push(ele?.createPermissionId);
			allIds.push(ele?.readPermissionId);
			allIds.push(ele?.updatePermissionId);
			allIds.push(ele?.deletePermissionId);
		});
		setselectedIds(allIds);
	};

	const onCheckboxSelected = (id: string) => {
		const allIds = selectedIds;
		if (allIds.indexOf(id) > -1) {
			setselectedIds((prev: any) => {
				let prevData = [...prev];
				prevData = prevData.filter((ele: string) => ele !== id);
				return prevData;
			});
		} else {
			setselectedIds((prevState: any) => {
				let prevData = prevState;
				prevData = prevData.concat(id);
				return prevData;
			});
		}
	};

	const checkBoxList = (id: string) => (
		<div>
			{id ? (
				<Checkbox
					onChange={() => {
						onCheckboxSelected(id);
					}}
					data-testid="checkbox-selection"
					name="CheckBoxOutlineBlankIcon"
					role="checkbox"
					checked={selectedIds.indexOf(id) !== -1}
					sx={{
						color: checkboxUncheckedcolor,
						'&.Mui-checked': { color: checkboxCheckedcolor },
						'&.MuiCheckbox-indeterminate': { color: checkboxCheckedcolor },
					}}
				/>
			) : null}
		</div>
	);

	useEffect(() => {
		onAcessPermissionSelect(selectedIds);
	}, [selectedIds]);

	useEffect(() => {
		if (selectedPermissionModules && selectedPermissionModules.length > 0) {
			setselectedIds(selectedPermissionModules);
		}
	}, [selectedPermissionModules && selectedPermissionModules.length]);

	useEffect(() => {
		if (selectButton) {
			getAllIds();
		}
	}, [selectButton]);

	useEffect(() => {
		if (clearButton) {
			setselectedIds([]);
		}
	}, [clearButton]);

	const dataPermissionColumns: Column[] = [
		{
			id: 'objectType',
			label: 'Data',
			disablePadding: false,
			render: (params: IDataPermission) => (
				<Typography className={styles['permission-modules-name']}>
					{pascalFormat(params.objectType)}
				</Typography>
			),
		},
		{
			id: 'createPermissionName',
			label: 'Create',
			disablePadding: false,
			render: (params: IDataPermission) => (
				<div>{checkBoxList(params?.createPermissionId)}</div>
			),
		},
		{
			id: 'readPermissionName',
			label: 'Read',
			disablePadding: false,
			render: (params: IDataPermission) => (
				<div>{checkBoxList(params?.readPermissionId)}</div>
			),
		},
		{
			id: 'updatePermissionName',
			label: 'Update',
			disablePadding: false,
			render: (params: IDataPermission) => (
				<div>{checkBoxList(params?.updatePermissionId)}</div>
			),
		},
		{
			id: 'deletePermissionName',
			label: 'Delete',
			disablePadding: false,
			render: (params: IDataPermission) => (
				<div>{checkBoxList(params?.deletePermissionId)}</div>
			),
		},
		{
			id: 'readAllPermissionName',
			label: 'Read All',
			disablePadding: false,
			render: (params: IDataPermission) => (
				<div>{checkBoxList(params?.readAllPermissionId)}</div>
			),
		},
		{
			id: 'updateAllPermissionName',
			label: 'Update All',
			disablePadding: false,
			render: (params: IDataPermission) => (
				<div>{checkBoxList(params?.updateAllPermissionId)}</div>
			),
		},
	];
	// set columns and rows data
	return (
		<CommonTable
			rows={data}
			columns={dataPermissionColumns}
			defaultSortKey=""
			tableStyles={{
				minWidth: '46.875em',
				maxHeight: '26em !important',
				minHeight: '26em !important',
			}}
			enableHeaderColor
			hidePagination
		/>
	);
};

export default DataAccessPermissionsModule;
